import { useState } from "react";

import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import {
    Chip,
    CircularProgress,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

import MuiSelect from "components/molecules/MuiSelect";

import FaceBookSdk from "../FaceBookSdk";
import { isArrayControl } from "./leadSourceSection.helpers";

/**
 * Facebook lead-source connect flow for LeadsStep1 (existing-source select,
 * page/form pickers, and the "Connect Facebook" button). All state that's
 * shared with the rest of the wizard still lives in LeadsStep1 and is passed
 * in as props; LeadsStep1 also still owns the `isflOptionsPermission` gate
 * that decides whether to render this at all.
 */
const FacebookLeadSourceSection = ({
    leadFbLoaderStatus,
    isUseFaceLeadPermission,
    connectedSourceInput,
    sourceConnectedList,
    fbSourceFormStatus,
    fbReadySourceSelectStatus,
    connectedSourceChange,
    resetConnectedSourceSelection,
    selectedConnectedSourceApiId,
    setNextButtonDisabled,
    appliedFBpermissionOpenSheet,
    sourceSettingsPermission,
    handleConnectionSourceName,
    connectionSourceName,
    selectedPages,
    connectFaceLeadsListChanged,
    handleSelectedPages,
    handleFbRefresh,
    changedSelectedPagesForms,
    selectedPageFormsValue,
    handleSelectedPagesForms,
    receiveNewForms,
    onToggleReceiveNewForms,
    showArchivedForms,
    onToggleShowArchivedForms,
    canReloadFacebookForms,
    isFacebookFormsLoading,
    includeAllForms,
    onToggleIncludeAllForms,
    updatedData,
}) => {
    const language = useSelector((state) => state.languagesState.languages);
    const appObject = useSelector((state) => state.setAppId.value);
    const [isFBAuthLoading, setIsFBAuthLoading] = useState(false);

    return (
        <>
            {leadFbLoaderStatus ? (
                <div className="d-flex justify-content-center align-items-center mt-5">
                    <CircularProgress size={20} />
                </div>
            ) : (
                <>
                    {isUseFaceLeadPermission && (
                        <>
                            {connectedSourceInput && (
                                <div className="mb-2">
                                    {isArrayControl(sourceConnectedList) && (
                                        <div>
                                            {fbSourceFormStatus === false &&
                                                fbReadySourceSelectStatus ===
                                                    false && (
                                                    <Form.Group
                                                        className="mb-2"
                                                        controlId="exampleForm.ControlInput1"
                                                    >
                                                        <FormControl
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            className="tour-facebook-exist-select"
                                                        >
                                                            <Select
                                                                data-cy="lead-existing-facebook-source"
                                                                id="id"
                                                                label={
                                                                    "Select Facebook Lead"
                                                                }
                                                                onChange={(
                                                                    event,
                                                                ) => {
                                                                    connectedSourceChange(
                                                                        event
                                                                            .target
                                                                            .value,
                                                                        sourceConnectedList.find(
                                                                            (
                                                                                x,
                                                                            ) =>
                                                                                x?.id ===
                                                                                event
                                                                                    .target
                                                                                    .value,
                                                                        ),
                                                                    );
                                                                    setNextButtonDisabled(
                                                                        false,
                                                                    );
                                                                }}
                                                                value={
                                                                    selectedConnectedSourceApiId
                                                                }
                                                            >
                                                                {sourceConnectedList &&
                                                                    sourceConnectedList.map(
                                                                        (
                                                                            item,
                                                                        ) => (
                                                                            <MenuItem
                                                                                key={
                                                                                    item.id
                                                                                }
                                                                                value={
                                                                                    item.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    item.name
                                                                                }
                                                                            </MenuItem>
                                                                        ),
                                                                    )}
                                                            </Select>
                                                        </FormControl>
                                                    </Form.Group>
                                                )}
                                        </div>
                                    )}
                                    {appliedFBpermissionOpenSheet && (
                                        <>
                                            {sourceSettingsPermission ===
                                                "success" && (
                                                <>
                                                    <div className="mb-3">
                                                        <FormControl
                                                            className="mb-3 fb-source"
                                                            style={{
                                                                width: "100%",
                                                                position:
                                                                    "relative",
                                                            }}
                                                        >
                                                            {fbReadySourceSelectStatus && (
                                                                <div className="fb-established-area">
                                                                    <span className="source-established-label">
                                                                        <FacebookOutlinedIcon></FacebookOutlinedIcon>
                                                                        {language
                                                                            ?.lead_wizard
                                                                            ?.facebook_connection_established ??
                                                                            "Facebook connection established"}
                                                                    </span>
                                                                    <button
                                                                        type="button"
                                                                        className="source-established-reset"
                                                                        onClick={
                                                                            resetConnectedSourceSelection
                                                                        }
                                                                    >
                                                                        {language
                                                                            ?.lead_wizard
                                                                            ?.reselect_source ??
                                                                            "Reselect source"}
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <TextField
                                                                data-cy="lead-facebook-source-name"
                                                                name="name"
                                                                label={
                                                                    "Source Name"
                                                                }
                                                                variant="outlined"
                                                                onChange={(e) =>
                                                                    handleConnectionSourceName(
                                                                        e,
                                                                    )
                                                                }
                                                                value={
                                                                    connectionSourceName
                                                                }
                                                                error={
                                                                    connectionSourceName ===
                                                                    ""
                                                                }
                                                                className="cloud-facebook-name-input text-field-ui-workaround"
                                                            />
                                                        </FormControl>
                                                        <div className="fb-pages-refresh-row">
                                                            <div className="tour-facebook-pages-select fb-pages-refresh-select">
                                                                <MuiSelect
                                                                    value={
                                                                        selectedPages
                                                                    }
                                                                    options={
                                                                        connectFaceLeadsListChanged
                                                                    }
                                                                    setValue={
                                                                        handleSelectedPages
                                                                    }
                                                                    label={
                                                                        language
                                                                            ?.lead_wizard
                                                                            ?.select_pages ??
                                                                        "Select page(s)"
                                                                    }
                                                                    labelId="facebook-page-select-label"
                                                                    multiple
                                                                    withChip
                                                                    renderSelectAll
                                                                    disableCloseOnSelect
                                                                />
                                                            </div>
                                                            <div className="fb-pages-refresh-action">
                                                                <Button
                                                                    onClick={
                                                                        handleFbRefresh
                                                                    }
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    className="facebook-login-btn fb-button-sm fb-refresh-btn tour-facebook-refresh-button"
                                                                    size="sm"
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faFacebookF
                                                                        }
                                                                        className="mr-2"
                                                                    />
                                                                    {language
                                                                        ?.lead
                                                                        ?.refresh ??
                                                                        "REFRESH"}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {canReloadFacebookForms && (
                                                        <FormControlLabel
                                                            className="mb-4"
                                                            control={
                                                                <Checkbox
                                                                    checked={
                                                                        showArchivedForms
                                                                    }
                                                                    onChange={
                                                                        onToggleShowArchivedForms
                                                                    }
                                                                    disabled={
                                                                        isFacebookFormsLoading
                                                                    }
                                                                />
                                                            }
                                                            label="Show archived forms"
                                                        />
                                                    )}
                                                    <div className="position-relative">
                                                        {isFacebookFormsLoading && (
                                                            <div
                                                                className="position-absolute d-flex justify-content-center align-items-center w-100 h-100"
                                                                style={{
                                                                    inset: 0,
                                                                    zIndex: 1,
                                                                    backgroundColor:
                                                                        "rgba(255, 255, 255, 0.65)",
                                                                }}
                                                            >
                                                                <CircularProgress
                                                                    size={20}
                                                                />
                                                            </div>
                                                        )}
                                                        <>
                                                            <Tooltip
                                                                title={
                                                                    !changedSelectedPagesForms.length &&
                                                                    "There is no forms for selected pages!"
                                                                }
                                                            >
                                                                <div className="mb-3">
                                                                    <MuiSelect
                                                                        value={
                                                                            selectedPageFormsValue
                                                                        }
                                                                        options={
                                                                            changedSelectedPagesForms
                                                                        }
                                                                        setValue={
                                                                            handleSelectedPagesForms
                                                                        }
                                                                        label={
                                                                            language
                                                                                ?.lead_wizard
                                                                                ?.select_forms ??
                                                                            "Select form(s)"
                                                                        }
                                                                        labelId="facebook-form-select-label"
                                                                        className="tour-facebook-form-select"
                                                                        multiple
                                                                        withChip
                                                                        renderSelectAll
                                                                        disableCloseOnSelect
                                                                        renderOptionLabel={(
                                                                            option,
                                                                        ) => (
                                                                            <Stack
                                                                                direction="row"
                                                                                alignItems="center"
                                                                                justifyContent="space-between"
                                                                                width="100%"
                                                                                spacing={
                                                                                    1
                                                                                }
                                                                            >
                                                                                <span>
                                                                                    {
                                                                                        option.label
                                                                                    }
                                                                                </span>
                                                                                <Chip
                                                                                    label={
                                                                                        option.status ===
                                                                                        0
                                                                                            ? "Archived"
                                                                                            : "Active"
                                                                                    }
                                                                                    color={
                                                                                        option.status ===
                                                                                        0
                                                                                            ? "default"
                                                                                            : "success"
                                                                                    }
                                                                                    size="small"
                                                                                    onClick={() => {}}
                                                                                />
                                                                            </Stack>
                                                                        )}
                                                                        disabled={
                                                                            isFacebookFormsLoading ||
                                                                            !changedSelectedPagesForms.length
                                                                        }
                                                                    />
                                                                </div>
                                                            </Tooltip>

                                                            {selectedPages.length >
                                                                0 && (
                                                                <div className="my-3">
                                                                    {canReloadFacebookForms && (
                                                                        <>
                                                                            <FormControlLabel
                                                                                className="newForm m-0"
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={
                                                                                            includeAllForms
                                                                                        }
                                                                                        onChange={
                                                                                            onToggleIncludeAllForms
                                                                                        }
                                                                                        disabled={
                                                                                            isFacebookFormsLoading
                                                                                        }
                                                                                    />
                                                                                }
                                                                                label="Connect all forms (including new ones)"
                                                                            />
                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                                sx={{
                                                                                    pl: 5.5,
                                                                                }}
                                                                            >
                                                                                Include
                                                                                all
                                                                                current
                                                                                forms
                                                                                and
                                                                                automatically
                                                                                receive
                                                                                future
                                                                                forms
                                                                                for
                                                                                the
                                                                                selected
                                                                                pages.
                                                                            </Typography>
                                                                        </>
                                                                    )}
                                                                    <FormControlLabel
                                                                        className="newForm m-0"
                                                                        control={
                                                                            <Checkbox
                                                                                checked={
                                                                                    includeAllForms ||
                                                                                    receiveNewForms
                                                                                }
                                                                                onChange={
                                                                                    onToggleReceiveNewForms
                                                                                }
                                                                                disabled={
                                                                                    includeAllForms ||
                                                                                    isFacebookFormsLoading
                                                                                }
                                                                            />
                                                                        }
                                                                        label={
                                                                            language
                                                                                ?.lead
                                                                                ?.forms_automatically ??
                                                                            "Add new forms automatically"
                                                                        }
                                                                    />
                                                                    <Typography
                                                                        variant="body2"
                                                                        color="text.secondary"
                                                                        sx={{
                                                                            pl: 5.5,
                                                                        }}
                                                                    >
                                                                        {language
                                                                            ?.lead
                                                                            ?.new_created_forms ??
                                                                            "New created forms will be included in your integration automatically"}
                                                                    </Typography>
                                                                </div>
                                                            )}
                                                        </>
                                                    </div>
                                                </>
                                            )}
                                            {sourceSettingsPermission ===
                                                "pending" && (
                                                <CircularProgress size={20} />
                                            )}
                                            {sourceSettingsPermission ===
                                                "error" && (
                                                <div className="d-flex justify-content-center align-items-center mt-1">
                                                    <p className="px-3">
                                                        {language?.lead
                                                            ?.you_do_not_have ??
                                                            "You do not have a Lead subscription"}
                                                    </p>
                                                    <a
                                                        class="font-weight-bold creatSubscription "
                                                        href={`${process.env.REACT_APP_CONSOLE_URL}/dash/subscriptions/trial/lead`}
                                                    >
                                                        {language?.lead
                                                            ?.start_lead_subscription ??
                                                            "Start Lead Subscription"}
                                                    </a>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {isArrayControl(sourceConnectedList) &&
                                        !fbSourceFormStatus &&
                                        !fbReadySourceSelectStatus && (
                                            <div className="wizard-or-area">
                                                Or Create New Facebook Lead
                                                Source
                                            </div>
                                        )}
                                </div>
                            )}
                            <div className="position-relative overflow-hidden z-1 mb-3">
                                {isFBAuthLoading && (
                                    <div className="circle-loader max-height-45">
                                        <ClipLoader color={"#000"} size={17} />
                                    </div>
                                )}
                                {((!sourceConnectedList?.length &&
                                    !connectFaceLeadsListChanged?.length) ||
                                    (!!sourceConnectedList?.length &&
                                        !!connectFaceLeadsListChanged?.length &&
                                        !fbSourceFormStatus) ||
                                    (!!sourceConnectedList?.length &&
                                        !connectFaceLeadsListChanged?.length)) &&
                                    !fbReadySourceSelectStatus && (
                                        <FaceBookSdk
                                            updatedData={updatedData}
                                            scope="email,pages_manage_ads,ads_management,pages_read_engagement,ads_read,pages_show_list,pages_manage_metadata,leads_retrieval,pages_show_list,pages_manage_metadata,business_management"
                                            appId={
                                                appObject.app_id &&
                                                appObject.app_id.toString()
                                            }
                                            version="v2.9"
                                            text="Connect Facebook"
                                            reRequest={true}
                                            setModalLoading={setIsFBAuthLoading}
                                        />
                                    )}
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default FacebookLeadSourceSection;
